import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdfOutlineViewComponent } from './pdf-outline-view.component';

const routes: Routes = [
  {
    path: '',
    component: PdfOutlineViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfOutlineViewRoutingModule { }
